<template>
  <div
    class="label"
    :class="{ '--underlined': underlined, '--large': size === 'large', '--has-tooltip': tooltip.length > 0 }"
    :style="tooltip.length > 0 ? 'cursor: help;' : ''"
  >
    {{ text }}
    <q-tooltip v-if="tooltip.length > 0" anchor="top middle" self="bottom middle">
      {{ tooltip }}
    </q-tooltip>
  </div>
</template>

<script>
export default {
  name: "Label",
  props: {
    text: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: "default"
    },
    underlined: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped lang="scss">
.label {
  font-weight: 500;
  color: color(gray);
  font-size: 85% !important;

  &.--underlined {
    text-decoration: underline;
    text-decoration-style: dashed;
    text-underline-offset: 2px;
  }

  &.--large {
    font-size: 1em !important;
    line-height: 1.3em;
  }
}
</style>
